import React from 'react';
import { Typography, Button } from 'antd';
import { primaryShades } from '../../../theme/theme';

const { Title } = Typography;

// Costanti dei colori
const PRIMARY_700 = primaryShades.primary700;

const HeaderComponent = ({
    title,
    buttonText,
    buttonIcon,
    onButtonClick,
    useSpaceBetween = false,
    isVisible,
    noCamp,
    rightContent,
    centerContent, // Nuovo prop per contenuto centrato
    buttonPosition = 'right'
}) => {
    const buttonComponent = isVisible && (
        <Button
            type="primary"
            icon={buttonIcon}
            iconPosition='start'
            onClick={onButtonClick}
            style={{ marginRight: buttonPosition === 'left' ? '1rem' : 0 }}
        >
            {buttonText}
        </Button>
    );

    // Se abbiamo centerContent, usiamo una struttura a 3 colonne
    if (centerContent) {
        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr auto 1fr',
                alignItems: 'center',
                padding: 'clamp(0.5rem, 2vw, 1rem) 0',
                marginBottom: noCamp ? '0' : 'clamp(0.5rem, 2vw, 1rem)',
                gap: '1rem'
            }}>
                {/* Colonna sinistra */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {buttonPosition === 'left' && buttonComponent}
                    <Title
                        level={2}
                        style={{
                            margin: 0,
                            color: PRIMARY_700,
                            fontSize: 'clamp(1.25rem, 4vw, 1.75rem)',
                            lineHeight: 'clamp(1.5rem, 4.5vw, 2rem)',
                            marginLeft: buttonPosition === 'left' ? '1rem' : 0
                        }}
                    >
                        {title}
                    </Title>
                </div>

                {/* Colonna centrale */}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {centerContent}
                </div>

                {/* Colonna destra */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                }}>
                    {buttonPosition === 'right' && buttonComponent}
                    {rightContent}
                </div>
            </div>
        );
    }

    // Layout originale senza centerContent
    return (
        <div style={{
            display: 'flex',
            justifyContent: useSpaceBetween ? 'space-between' : 'flex-start',
            alignItems: 'center',
            padding: 'clamp(0.5rem, 2vw, 1rem) 0',
            marginBottom: noCamp ? '0' : 'clamp(0.5rem, 2vw, 1rem)'
        }}>
            {buttonPosition === 'left' && buttonComponent}

            <Title
                level={2}
                style={{
                    margin: 0,
                    color: PRIMARY_700,
                    fontSize: 'clamp(1.25rem, 4vw, 1.75rem)',
                    lineHeight: 'clamp(1.5rem, 4.5vw, 2rem)'
                }}
            >
                {title}
            </Title>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: useSpaceBetween ? 'auto' : '1rem'
            }}>
                {buttonPosition === 'right' && buttonComponent}
                {rightContent}
            </div>
        </div>
    );
};

export default HeaderComponent; 